<template>
  <div class="table-page-wrapper">

    <div v-show="searchStatus" class="search-wrapper">

      <base-date-picker @changeDate="changeDate" style="margin-right: 15px;" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px;">
        <el-button @click="downExcel('/report/media/channel/time/csv', '时段报表', tableParams)" type="warning" size="small">下载</el-button>
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{background:'#fafafa'}"
        :summary-method="tableSummary"
        show-summary
        highlight-current-row
        size="small"
        class="js-table"
        style="width: 100%">
          <el-table-column
            v-for="(v, i) in checkColumns"
            :prop="v.field"
            :label="v.title"
            :width="v.width"
            sortable
            :min-width="v.minWidth"
            :key="i"
            align="center">
            <template v-slot="scope">
              <el-tag v-if="v.field === 'clickRate'" type="info">{{ scope.row[v.field] }}%</el-tag>
              <span v-else>{{ scope.row[v.field] }}</span>
            </template>
          </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px;" />
    </div>
  </div>
</template>

<script>
import BaseDatePicker from '@/components/BaseDatePicker'
import TableColumn from '@/components/TableColumn'

import initTableMixin from '@/mixins/initTable'
import downExcelMixin from '@/mixins/downExcel'

export default {
  name: 'reportChannelTime',
  components: {
    BaseDatePicker,
    TableColumn
  },
  mixins: [initTableMixin, downExcelMixin],
  data () {
    return {
      columns: [
        { field: 'reportTime', title: '日期' },
        { field: 'showSmt', title: '展示数' },
        { field: 'ecpm', title: 'eCPM' },
        { field: 'clkSmt', title: '点击数' },
        { field: 'clickRate', title: '点击率' },
        { field: 'income', title: '预计收入' }
      ]
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/report/media/channel/time'
      this.tableParams.pageNum = this.pagination.pageNum
      this.tableParams.pageSize = this.pagination.pageSize
      return true
    },
    changeDate (date) {
      this.tableParams.startTime = date.startTime
      this.tableParams.endTime = date.endTime
    },
    sizeChange(e) {
      this.pagination.pageSize = e
      this.tableParams.pageSize = e
      this.init()
    },
    currentChange(e) {
      this.pagination.pageNum = e
      this.tableParams.pageNum = e
      this.init()
    },
    tableSummary (row) {
      const arr = ['showSmt', 'ecpm', 'clkSmt', 'income']
      const fixedArr = ['ecpm',"income",'clickRate']
      const {data } = row
      let checklists=this.checkColumns.map(item=>{
        return item.field
      })
      const out = []
      for (let i = 0; i < checklists.length; i++) {
        if (i === 0) {
          out[i] = '合计'
        } else {
          if (fixedArr.indexOf(checklists[i]) > -1) {
            if(checklists[i]=='clickRate'){
              out[i]=((data.reduce((total, item) => { return total + Number(item["clkSmt"]) }, 0))/(data.reduce((total, item) => { return total + Number(item["showSmt"]) }, 0))*100).toFixed(2)
            }else{
              out[i] =(data.reduce((total, item) => { return total + Number(item[checklists[i]]) }, 0)).toFixed(2)
            }
          } else {
            out[i] = arr.indexOf(checklists[i]) > -1 ? data.reduce((total, item) => { return total + Number(item[checklists[i]]) }, 0) : '-'
          }
        }
      }
      return out
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper{
  padding: 15px 15px 15px;
  margin-bottom: 10px;
  background: #ffffff;
  &>*{
    margin-right: 15px;
    margin-bottom: 10px;
    &:last-child{
      margin-right: 0;
    }
  }

  &>.el-select,&>.el-input{
    width: 220px;
  }
}

.table-wrapper{
  padding: 15px;
  background: #ffffff;
  .table__operation{
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}
</style>
